import { createContext } from "react";

// The signed-in session. Provided by SessionProvider, read through
// useSession(). Shape:
//
//   status                "loading" | "authenticated" | "anonymous"
//   kind                  "USER" (staff) | "STUDENT" | null
//   user                  staff user from meResolver, or null
//   student               student from meResolver, or null
//   selectedHeadquarterId the sede a staff user is working in
//   login(token)          store a token from a login mutation, load the session
//   logout()              forget the session on this device
//   refresh()             reload the session from the API
//   selectHeadquarter(id) switch sede and refetch what is on screen
export const SessionContext = createContext(null);
